import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import { ApiFactory } from "@/api/ApiFactory.js";
import router from "@/router";

Vue.use(Vuex);
const authApi = ApiFactory.get("auth");

const state = {
    auth: {
        isAuthentificated: false,
        username: "",
        password: "",
        userId: null
    },
    menu: {},
    version: "",
    currentPage: "",
    settings: {
        lang: null,
        size: "sm",
        persistentFilterStoring: false
    },
    alert: {},
    errors: [],
    pages: {
        mitglieder: {
            filterShown: true
        },
        probenplan: {
            selectedDate: null
        },
        singpause: {
            schoolYear: null
        },
        fibu_buchung: {
            filter: null,
            sumLists: [],
            sumCollectionVisible: false,
            pagination: {
                step: 50,
                total: 0,
                current: 1
            }
        },
        fibu_offene_posten: {
            filter: null,
            pagination: {
                step: 15,
                total: 0,
                current: 1
            }
        },
        fibu_kontenblaetter: {
            filter: {}
        }
    }
};
const defaultState = state;

const getters = {
    getAuth: state => state.auth,
    getMenu: state => state.menu,
    getCurrentPage: state => state.currentPage,
    getSettings: state => state.settings,
    getAlert: state => state.alert,
    getPages: state => state.pages,
    getErrors: state => state.errors,
    getVersion: state => state.version
};

var mutations = {
    AUTH: (state, payload) => {
        var auth = state.auth;
        auth.isAuthentificated = payload.isAuthentificated;
        auth.username = payload.username;
        auth.password = payload.password;
        auth.userId = payload.userId;
    },
    LOGOUT: (state, payload) => {
        state = Object.assign(state, {
            auth: {
                isAuthentificated: false,
                username: "",
                password: "",
                userId: null
            },
            menu: {},
            currentPage: "",
            alert: {},
            errors: [],
            pages: {
                mitglieder: {
                    filterShown: true
                }
            }
        });
    },
    CLEAN: (state, payload) => {
        state = Object.assign(state, {
            menu: {},
            currentPage: "",
            alert: {},
            errors: [],
            pages: {
                mitglieder: {
                    filterShown: true
                }
            }
        });
    },
    MENU: (state, payload) => {
        state.menu = payload;
    },
    CURRENT_PAGE: (state, payload) => {
        state.currentPage = payload;
    },
    SETTINGS: (state, payload) => {
        state.settings = payload;
    },
    ALERT: (state, payload) => {
        state.alert = payload;
    },
    PAGES: (state, payload) => {
        var pages = state.pages;
        const pagesPayload = Object.keys(payload);
        pagesPayload.forEach(key => {
            if (pages[key]) {
                Object.assign(pages[key], { ...payload[key] });
            } else {
                pages[key] = payload[key];
            }
        });
    },
    VERSION: (state, payload) => {
        state.version = payload;
    },
    ERROR: (state, payload) => {
        state.errors.push(payload);
    }
};

var actions = {
    auth: async ({ commit, dispatch }, payload) => {
        var username = payload.username;
        var password = payload.password;

        commit("AUTH", {
            isAuthentificated: false,
            username: username,
            password: password
        });

        const response = await authApi.get();
        var isAuthentificated = false;
        var userId = null;
        if (response.status === 200) {
            isAuthentificated = true;
            userId = response.json.user_id;
        } else {
            isAuthentificated = false;
            username = "";
            password = "";
            userId = null;
        }

        const v2response = await fetch(
            '/api/login',
            {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    username: username,
                    password: password
                })
            }
        );
        if (!v2response.status === 204) {
            console.log(await v2response.json());
        }

        commit("AUTH", {
            isAuthentificated: isAuthentificated,
            username: username,
            password: password,
            userId: userId
        });

        if (!isAuthentificated) {
            throw new Error("Wrong login credentials");
        }
        //dispatch("menu", response);
    },
    logout: (context, payload) => {
        context.commit("LOGOUT", payload);
    },
    menu: async (context, payload) => {
        if (payload.ok) {
            var json = payload.json;
            if (json.hasOwnProperty("_embedded")) {
                if (json._embedded.hasOwnProperty("menu")) {
                    var menuArr = {};
                    json._embedded.menu.forEach(element => {
                        if (typeof element.group === "undefined") {
                            return;
                        }
                        if (!menuArr[element.group]) {
                            menuArr[element.group] = [];
                        }
                        menuArr[element.group].push(element);
                    });
                    context.commit("MENU", menuArr);
                }
            }
        }
    },
    currentPage: (context, payload) => {
        var path = payload.path;
        context.commit("CURRENT_PAGE", path);
    },
    settings: (context, payload) => {
        context.commit("SETTINGS", payload);
    },
    pages: (context, payload) => {
        context.commit("PAGES", payload);
    },
    version: (context, payload) => {
        const storedVersion = context.getters.getVersion;
        console.log("version", storedVersion);
        context.commit("VERSION", payload);
        if (storedVersion !== "") {
            context.commit("CLEAN");
            router.go();
        }
    },
    error: (context, payload) => {
        context.commit("ERROR", payload);
        if (payload.status !== 403 && !payload.validation) {
            context.commit("ALERT", payload);
        }
        if (process.env.VUE_APP_MODE !== "production") {
            console.error(payload.heading + " -> " + payload.text);
        }
    }
};

const vuexPersist = new VuexPersist({
    key: "mv-verwaltung",
    storage: localStorage,
    reducer: state => ({
        auth: state.auth,
        version: state.version,
        settings: state.settings,
        menu: state.menu,
        pages: state.settings.persistentFilterStoring
            ? state.pages
            : {
                  mitglieder: {
                      filterShown: true
                  },
                  probenplan: {
                      selectedDate: null
                  },
                  singpause: {
                      schoolYear: null
                  },
                  fibu_buchung: {
                      filter: null,
                      sumLists: [],
                      sumCollectionVisible: false
                  },
                  fibu_offene_posten: {
                      filter: null
                  }
              }
    })
});

export default new Vuex.Store({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions,
    plugins: [vuexPersist.plugin]
});
